module.exports = __webpack_public_path__ + "static/media/56.f3113fb.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/56.wav
// module id = 2S+N
// module chunks = 0